const getters = {
    getCustomers: (state) => {
        let customers = _.toArray(state.customers);
    
         return customers;
      },}

export default getters